import api from "./Api";

class EmitenteSoftwareHouseService {
  GetEmitenteSoftwareHouse(payload) {
    return api.get("/v1/emitenteSoftwareHouse/" + payload).then((response) => {
      return response.data;
    });
  }

  PostEmitenteSoftwareHouse(payload) {
    return api.post("/v1/emitenteSoftwareHouse/", payload).then((response) => {
      return response.data;
    });
  }

  PutEmitenteSoftwareHouse(payload) {
    return api.put("/v1/emitenteSoftwareHouse/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteEmitenteSoftwareHouse(payload) {
    return api
      .delete("/v1/emitenteSoftwareHouse/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetEmitenteSoftwareHouseOData(payload) {
    return api
      .get("/OData/EmitenteSoftwareHouse" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new EmitenteSoftwareHouseService();
